INBOUND_TRACKING_QUERY_VARS